import { render, staticRenderFns } from "./GroupSideInfo.vue?vue&type=template&id=7a5c832f"
import script from "./GroupSideInfo.vue?vue&type=script&lang=js"
export * from "./GroupSideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports